import { Mesh } from '@babylonjs/core/Meshes/mesh';

import { SystemCamera } from '../System/systemCamera';
import { Catcher } from './catcher';

export enum MeshEvent {
    Enter,
    Leave,
}

/**
 * Detect Mesh action of the user
 */

export class MeshCatcher extends Catcher<MeshEvent, Mesh> {
    currentMesh: Mesh

    constructor(system: SystemCamera) {
        super(system, 'MeshCatcher');
        this.system.canvas.addEventListener('pointermove', (evt) => {
            if (this.catching) {
                // We try to pick an object
                const pickResult = system.pick(evt);
                const { pickedMesh } = pickResult;
                if (pickedMesh) {
                    if (pickedMesh !== this.currentMesh) {
                        this.notify(MeshEvent.Enter, pickedMesh);
                        this.currentMesh = pickedMesh;
                    }
                } else if (this.currentMesh) {
                    this.notify(MeshEvent.Leave, null);
                    this.currentMesh = null;
                }
            }
        });
    }
}
